import { lazy } from 'react';
import { Route } from 'react-router-dom';
import { LazyRoute } from './LazyRoute';

const GenerateStoryPage = lazy(() => import('@/features/story/pages/GenerateStoryPage'));
const StoryPage = lazy(() => import('@/features/story/pages/StoryPage'));
const ThemeAssignmentPage = lazy(() => import('@/features/story/pages/ThemeAssignmentPage'));
const LibraryPage = lazy(() => import('@/features/library/pages/LibraryPage'));

export const storyRoutes = (
  <>
    <Route path="/library/story/create" element={<LazyRoute><GenerateStoryPage /></LazyRoute>} />
    <Route path="/assignments/theme/:themeId" element={<LazyRoute><ThemeAssignmentPage /></LazyRoute>} />
    <Route path="/story/:id" element={<LazyRoute><StoryPage /></LazyRoute>} />
    <Route path="/library" element={<LazyRoute><LibraryPage /></LazyRoute>} />
  </>
);
